import $i18n from '../lang/index';
// 运单状态列表（waybillStatusList）加载的是本地静态数据，切换语言时数据不会同步更新。
export const waybillStatusList = [
  // { label: $i18n.t('newOrder.all'), code: 0 }, // 待分配
  // { label: $i18n.t('newOrder.ToBeAssigned'), code: 1 }, // 待分配
  { label: $i18n.t('collectionCenter.orderPlaced'), code: 30 }, // 已下单
  { label: $i18n.t('newOrder.ToBeCollected'), code: 2 }, // 待揽收
  { label: $i18n.t('newOrder.Collected'), code: 3 }, // 已揽收
  // { label: $i18n.t('newOrder.CollectTheRevenuePool'), code: 4 }, // 揽收入库
  // { label: $i18n.t('newOrder.CollectTakeOutWarehouse'), code: 5 }, // 揽收出库
  // { label: $i18n.t('newOrder.Collected'), code: 19 }, // 末端已揽收   ===>   已揽收
  { label: $i18n.t('newOrder.TransshipmentIntoStorage'), code: 6 }, // 转运入库
  { label: $i18n.t('newOrder.TransferOutWarehouse'), code: 7 }, // 转运出库
  { label: $i18n.t('newOrder.DeliveryOutletsIntoStorage'), code: 8 }, // 派送网点入库
  { label: $i18n.t('newOrder.Delivering'), code: 9 }, // 派送中
  { label: $i18n.t('newOrder.Signed'), code: 10 }, // 已签收
  { label: $i18n.t('newOrder.ProblemPiece'), code: 11 }, // 问题件
  { label: $i18n.t('GlobalSetObj.warehouseRetentionItem'), code: 29 }, // 留仓件
  { label: $i18n.t('GlobalSetObj.Canceled'), code: 13 }, // 已取消
  // // { label: $i18n.t('GlobalSetObj.deliveryFailure'), code: 14 }, // 投递失败
  { label: $i18n.t('GlobalSetObj.DotBack'), code: 17 }, // 网点退回
  { label: $i18n.t('GlobalSetObj.ReturnToStorage'), code: 18 }, // 退仓入库
  { label: $i18n.t('GlobalSetObj.Withdrawn'), code: 15 }, // 退件中
  { label: $i18n.t('GlobalSetObj.TheReturnComplete'), code: 16 }, // 退件完成
  { label: $i18n.t('GlobalSetObj.mutilSign'), code: 20 }, // 多次签收
  // { label: $i18n.t('GlobalSetObj.financialProcessing'), code: 21 }, // 财务处理中
  // { label: $i18n.t('GlobalSetObj.financialClosedLoop'), code: 22 } // 财务闭环
  { label: $i18n.t('GlobalSetObj.acceptCarriageSwitch'), code: 27 } // 承运更换
];
// 函数可根据当前语言环境按需返回本地化的运单状态列表
export const getWaybillStatusList = () => [
  // { label: $i18n.t('newOrder.all'), code: 0 }, // 待分配
  // { label: $i18n.t('newOrder.ToBeAssigned'), code: 1 }, // 待分配
  { label: $i18n.t('collectionCenter.orderPlaced'), code: 30 }, // 已下单
  { label: $i18n.t('newOrder.ToBeCollected'), code: 2 }, // 待揽收
  { label: $i18n.t('newOrder.Collected'), code: 3 }, // 已揽收
  // { label: $i18n.t('newOrder.CollectTheRevenuePool'), code: 4 }, // 揽收入库
  // { label: $i18n.t('newOrder.CollectTakeOutWarehouse'), code: 5 }, // 揽收出库
  // { label: $i18n.t('newOrder.Collected'), code: 19 }, // 末端已揽收   ===>   已揽收
  { label: $i18n.t('newOrder.TransshipmentIntoStorage'), code: 6 }, // 转运入库
  { label: $i18n.t('newOrder.TransferOutWarehouse'), code: 7 }, // 转运出库
  { label: $i18n.t('newOrder.DeliveryOutletsIntoStorage'), code: 8 }, // 派送网点入库
  { label: $i18n.t('newOrder.Delivering'), code: 9 }, // 派送中
  { label: $i18n.t('newOrder.Signed'), code: 10 }, // 已签收
  { label: $i18n.t('newOrder.ProblemPiece'), code: 11 }, // 问题件
  { label: $i18n.t('GlobalSetObj.warehouseRetentionItem'), code: 29 }, // 留仓件
  { label: $i18n.t('GlobalSetObj.Canceled'), code: 13 }, // 已取消
  // // { label: $i18n.t('GlobalSetObj.deliveryFailure'), code: 14 }, // 投递失败
  { label: $i18n.t('GlobalSetObj.DotBack'), code: 17 }, // 网点退回
  { label: $i18n.t('GlobalSetObj.ReturnToStorage'), code: 18 }, // 退仓入库
  { label: $i18n.t('GlobalSetObj.Withdrawn'), code: 15 }, // 退件中
  { label: $i18n.t('GlobalSetObj.TheReturnComplete'), code: 16 }, // 退件完成
  { label: $i18n.t('GlobalSetObj.mutilSign'), code: 20 }, // 多次签收
  // { label: $i18n.t('GlobalSetObj.financialProcessing'), code: 21 }, // 财务处理中
  // { label: $i18n.t('GlobalSetObj.financialClosedLoop'), code: 22 } // 财务闭环
  { label: $i18n.t('GlobalSetObj.acceptCarriageSwitch'), code: 27 } // 承运更换
];

export const waybillStatusObj = {
  // 1: { label: $i18n.t('newOrder.ToBeAssigned'), code: 1 }, // 待分配
  2: { label: $i18n.t('newOrder.ToBeCollected'), code: 2 }, // 待揽收
  3: { label: $i18n.t('newOrder.Collected'), code: 3 }, // 已揽收
  // 4: { label: $i18n.t('newOrder.CollectTheRevenuePool'), code: 4 }, // 揽收入库
  // 5: { label: $i18n.t('newOrder.CollectTakeOutWarehouse'), code: 5 }, // 揽收出库
  19: { label: $i18n.t('newOrder.Collected'), code: 19 }, // 末端已揽收   ===>  已揽收
  6: { label: $i18n.t('newOrder.TransshipmentIntoStorage'), code: 6 }, // 转运入库
  7: { label: $i18n.t('newOrder.TransferOutWarehouse'), code: 7 }, // 转运出库
  8: { label: $i18n.t('newOrder.DeliveryOutletsIntoStorage'), code: 8 }, // 派送网点入库
  9: { label: $i18n.t('newOrder.Delivering'), code: 9 }, // 派送中
  10: { label: $i18n.t('newOrder.Signed'), code: 10 }, // 已签收
  11: { label: $i18n.t('newOrder.ProblemPiece'), code: 11 }, // 问题件
  12: { label: $i18n.t('collectionCenter.unclaimed'), code: 12 }, // 待取件
  13: { label: $i18n.t('GlobalSetObj.Canceled'), code: 13 }, // 已取消
  17: { label: $i18n.t('GlobalSetObj.DotBack'), code: 17 }, // 网点退回
  18: { label: $i18n.t('GlobalSetObj.ReturnToStorage'), code: 18 }, // 退仓入库
  15: { label: $i18n.t('GlobalSetObj.Withdrawn'), code: 15 }, // 退件中
  16: { label: $i18n.t('GlobalSetObj.TheReturnComplete'), code: 16 }, // 退件完成
  20: { label: $i18n.t('GlobalSetObj.mutilSign'), code: 20 }, // 多次签收
  21: { label: $i18n.t('GlobalSetObj.financialProcessing'), code: 21 }, // 财务处理中
  22: { label: $i18n.t('GlobalSetObj.financialClosedLoop'), code: 22 }, // 财务闭环
  29: { label: $i18n.t('GlobalSetObj.warehouseRetentionItem'), code: 29 }, // 留仓件
  30: { label: $i18n.t('collectionCenter.orderPlaced'), code: 30 }, // 已下单
  200: { label: '', code: 200 } // 问题件
};
export const headerList = [
  { id: 2, label: $i18n.t('newOrder.orderCreateTime'), prop: 'createTime', cloWidth: 180 },
  // 客户名称
  {
    id: 21,
    label: $i18n.t('newOrder.CustomerName'),
    prop: 'customerName',
    clickClass: false,
    cloWidth: 100
  },
  { id: 3, label: $i18n.t('newOrder.waybillStatus'), prop: 'waybillStatusName' },
  {
    id: 30,
    label: $i18n.t('orderCenterCont.latestStatusTime'),
    prop: 'lastTrackTime',
    cloWidth: 180
  },
  {
    id: 50,
    label: $i18n.t('orderCenterCont.zuixinguijineir'),
    prop: 'lastTrackDescribe',
    cloWidth: 180
  },
  { id: 51, label: $i18n.t('orderCenterCont.wentijianyuanyin'), prop: 'deliveryFailReason' },
  { id: 52, label: $i18n.t('placeOrder.cargoType'), prop: 'cargoTypeName' },
  { id: 53, label: $i18n.t('customerManagements.customerChannel'), prop: 'customerChannel', cloWidth: 120 },
  {
    id: 5,
    label: $i18n.t('newOrder.orderNumber'),
    prop: 'customerNumber',
    clickClass: false,
    cloWidth: 180
  },
  {
    id: 1,
    label: $i18n.t('orderCenterCont.anjunWaybillNumber'), // 安骏运单号
    prop: 'waybillNumber',
    cloWidth: 200
  },
  {
    id: 999,
    label: $i18n.t('GlobalSetObj.ScanNumber'),
    prop: 'scanOrderNumber',
    cloWidth: 180
  },
  {
    id: 20250512,
    label: $i18n.t('GlobalSetObj.anJunOrderNumber'), // 安骏订单号
    prop: 'orderNumber',
    cloWidth: 180
  },
  {
    id: 4,
    label: $i18n.t('GlobalSetObj.serviceLogistics'),
    prop: 'logisticsNumber',
    clickClass: false,
    cloWidth: 180
  },
  {
    id: 565,
    label: $i18n.t('collectionCenter.relatedWaybillNumber'),
    prop: 'forwardWaybillNumber',
    cloWidth: 180
  },
  {
    id: 566,
    label: $i18n.t('collectionCenter.tipoTitle'),
    prop: 'orderType',
    cloWidth: 180
  },
  {
    id: 31,
    label: $i18n.t('newOrder.ActualCollection'),
    prop: 'collectStationName',
    cloWidth: 100
  },
  // 揽收袋号
  // { id: 8, label: $i18n.t('orderCenterCont.PickUpBagNumber'), prop: 'bagNumber', cloWidth: 120 },
  // 派送距离
  {
    id: 993,
    label: $i18n.t('newOrder.deliveryDistance'),
    prop: 'deliveryDistance',
    clickClass: false,
    cloWidth: 120
  },
  {
    id: 39,
    label: $i18n.t('GlobalSetObj.preEntrega'),
    prop: 'preDeliverStationName',
    cloWidth: 100
  },
  { id: 32, label: $i18n.t('GlobalSetObj.entrega'), prop: 'deliverStationName' },
  { id: 994, label: $i18n.t('orderCenterCont.deliveryPerson'), prop: 'deliveryManName' },
  { id: 997, label: $i18n.t('GlobalSetObj.CustomerWeight'), prop: 'customerWeight' },
  {
    id: 33,
    label: $i18n.t('orderCenterCont.incomingWeightOfTransitWarehouse'),
    prop: 'transportWeight'
  },
  // 开票金额 BRL
  {
    id: 1009,
    label: $i18n.t('placeOrder.InvoiceAmount') + '(BRL)',
    prop: 'invoiceMoney',
    clickClass: false,
    cloWidth: 120
  },
  // 中转仓袋号
  {
    id: 9,
    label: $i18n.t('orderCenterCont.TransitBinBagNumber'),
    prop: 'transitBagNumber',
    clickClass: false,
    cloWidth: 120
  },
  { id: 34, label: $i18n.t('newOrder.RecipientName'), prop: 'receiveName' },
  { id: 35, label: $i18n.t('newOrder.RecipientZipCode'), prop: 'receiveZipcode' },
  { id: 36, label: $i18n.t('orderCenterCont.recipientProvince'), prop: 'receiveState' },
  { id: 37, label: $i18n.t('newOrder.RecipientCity'), prop: 'receiveCity' },
  { id: 40, label: $i18n.t('orderCenterCont.SenderzipCode'), prop: 'senderZipcode' },
  { id: 41, label: $i18n.t('orderCenterCont.SenderProvince'), prop: 'senderState' },
  { id: 42, label: $i18n.t('orderCenterCont.SenderCity'), prop: 'senderCity' },
  { id: 500, label: $i18n.t('home.nfeInvoiceNumber'), prop: 'invoiceNumber' },
  { id: 501, label: $i18n.t('home.nfeInvoiceKey'), prop: 'invoiceAccessKey' },
  {
    id: 43,
    label: $i18n.t('orderCenterCont.customerDeliveryTime'),
    prop: 'customerSendTime'
  },
  {
    id: 44,
    label: $i18n.t('orderCenterCont.customerDeliveryStatusDescription'),
    prop: 'customerSendStatus'
  },
  { id: 488, label: $i18n.t('newOrder.orderNote'), prop: 'waybillRemark' },
  { id: 489, label: $i18n.t('collectionCenter.MerchantNum'), prop: 'merchantCode' },
  { id: 490, label: $i18n.t('collectionCenter.MerchantName'), prop: 'merchantName' },
  // { id: 491, label: $i18n.t('newOrder.InvoiceKey'), prop: 'invoiceKey' }
  { id: 492, label: $i18n.t('orderCenterCont.OrderSource'), prop: 'orderSourceName' }
];

export const tableHeaderForm = [
  $i18n.t('newOrder.orderCreateTime'),
  $i18n.t('newOrder.CustomerName'),
  $i18n.t('newOrder.waybillStatus'),
  $i18n.t('orderCenterCont.latestStatusTime'),
  $i18n.t('orderCenterCont.zuixinguijineir'),
  $i18n.t('orderCenterCont.wentijianyuanyin'),
  $i18n.t('placeOrder.cargoType'),
  $i18n.t('newOrder.orderNumber'),
  $i18n.t('orderCenterCont.anjunWaybillNumber'),
  $i18n.t('GlobalSetObj.ScanNumber'),
  $i18n.t('GlobalSetObj.anJunOrderNumber'),
  $i18n.t('GlobalSetObj.serviceLogistics'),
  $i18n.t('collectionCenter.relatedWaybillNumber'),
  $i18n.t('collectionCenter.tipoTitle'),
  $i18n.t('newOrder.ActualCollection'),
  $i18n.t('GlobalSetObj.preEntrega'),
  $i18n.t('orderCenterCont.customerDeliveryTime'),
  $i18n.t('orderCenterCont.customerDeliveryStatusDescription'),
  $i18n.t('GlobalSetObj.entrega'),
  $i18n.t('orderCenterCont.deliveryPerson'),
  $i18n.t('GlobalSetObj.CustomerWeight'),
  $i18n.t('placeOrder.InvoiceAmount') + '(BRL)',
  $i18n.t('orderCenterCont.incomingWeightOfTransitWarehouse'),
  $i18n.t('orderCenterCont.TransitBinBagNumber'),
  $i18n.t('newOrder.RecipientName'),
  $i18n.t('newOrder.RecipientZipCode'),
  $i18n.t('orderCenterCont.recipientProvince'),
  $i18n.t('newOrder.RecipientCity'),
  $i18n.t('orderCenterCont.SenderzipCode'),
  $i18n.t('orderCenterCont.SenderProvince'),
  $i18n.t('orderCenterCont.SenderCity'),
  $i18n.t('newOrder.deliveryDistance'),
  $i18n.t('newOrder.orderNote'),
  $i18n.t('collectionCenter.MerchantNum'),
  $i18n.t('collectionCenter.MerchantName'),
  $i18n.t('orderCenterCont.OrderSource')
];
export const processingResultList = [
  { label: $i18n.t('GlobalSetObj.blameless'), value: 1 },
  { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 0 },
  // 需求：应客服部要求，关闭按钮去掉【全部丢失】的选项。
  // { label: $i18n.t('compensationManagement.lossOfAll'), value: 2 },
  { label: $i18n.t('compensationManagement.PartiallyLost'), value: 3 },
  { label: $i18n.t('home.goodsNOfuhe'), value: 5 },
  { label: $i18n.t('home.infoError'), value: 6 },
  { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
  { label: $i18n.t('tablePrice.invalidResponse'), value: 8 },
  { label: $i18n.t('tablePrice.confirmedLost'), value: 10 },
  { label: $i18n.t('compensationManagement.trackingUpdated'), value: 11 },
  { label: $i18n.t('compensationManagement.established'), value: 12 },
  { label: $i18n.t('compensationManagement.notEstablished'), value: 13 }
];
export const processingResultObj = {
  0: $i18n.t('compensationManagement.FalseSigningForDelivery'), // 虚假签收
  1: $i18n.t('GlobalSetObj.blameless'), // 无责
  3: $i18n.t('compensationManagement.PartiallyLost'),
  5: $i18n.t('home.goodsNOfuhe'),
  6: $i18n.t('home.infoError'),
  7: $i18n.t('home.moreTimeNotReply'),
  8: $i18n.t('tablePrice.invalidResponse'),
  10: $i18n.t('tablePrice.confirmedLost'),
  11: $i18n.t('compensationManagement.trackingUpdated'),
  12: $i18n.t('compensationManagement.established'),
  13: $i18n.t('compensationManagement.notEstablished'),
  20: $i18n.t('collectionCenter.complaintType1'),
  21: $i18n.t('collectionCenter.complaintType2'),
  22: $i18n.t('collectionCenter.complaintType3'),
  23: $i18n.t('collectionCenter.complaintType4'),
  24: $i18n.t('collectionCenter.complaintType5'),
  25: $i18n.t('collectionCenter.complaintType6'),
  26: $i18n.t('collectionCenter.complaintType7')
};
// 问题件分类
export const problemtypesObj = {
  0: $i18n.t('collectionCenter.lanshou'), // 揽收
  1: $i18n.t('collectionCenter.dispatch') // 派送
};
// 问题件类型分类
export const problemtypeLeixingObj = {
  0: $i18n.t('changepwd.putongProblem'), // 普通问题件
  1: $i18n.t('changepwd.teshuProblem') // 特殊问题件
};
// 问题件层级
export const IssueLevel = {
  1: $i18n.t('changepwd.oneLeave'), // 一级
  2: $i18n.t('changepwd.twoLeave') // 二级
};
//  投诉来源
export const complaintSourceObj = {
  0: $i18n.t('tablePrice.consumerComplaint'), // 消费者投诉
  1: $i18n.t('tablePrice.platformComplaint'), // 平台投诉
  2: $i18n.t('compensationManagement.systemAutoDetermination'),
  3: 'Chat',
  4: 'E-mail',
  5: 'Octadesk'
};
export const complaintSourceList = [
  { label: $i18n.t('tablePrice.consumerComplaint'), value: 0 },
  { label: $i18n.t('tablePrice.platformComplaint'), value: 1 },
  { label: $i18n.t('compensationManagement.systemAutoDetermination'), value: 2 },
  { label: 'Chat', value: 3 },
  { label: 'E-mail', value: 4 },
  { label: 'Octadesk', value: 5 }
];
//  投诉类型
export const complaintTypeObj = {
  1: $i18n.t('compensationManagement.FalseSigningForDelivery'),
  0: $i18n.t('operationTips.yisiLost'),
  2: $i18n.t('compensationManagement.wrongOrMissingItems'),
  3: $i18n.t('compensationManagement.damagedItems'),
  4: $i18n.t('compensationManagement.CommercialComplaint'),
  5: 'Reclame Aqui',
  6: $i18n.t('compensationManagement.outOfUpdate'),
  7: $i18n.t('compensationManagement.deliveryDelay'),
  8: $i18n.t('compensationManagement.falseDelivery'),
  9: $i18n.t('compensationManagement.otherType')
};
export const complaintTypeList = [
  { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 1 },
  { label: $i18n.t('operationTips.yisiLost'), value: 0 },
  { label: $i18n.t('compensationManagement.wrongOrMissingItems'), value: 2 },
  { label: $i18n.t('compensationManagement.damagedItems'), value: 3 },
  { label: $i18n.t('compensationManagement.CommercialComplaint'), value: 4 },
  { label: 'Reclame Aqui', value: 5 },
  { label: $i18n.t('compensationManagement.outOfUpdate'), value: 6 },
  { label: $i18n.t('compensationManagement.deliveryDelay'), value: 7 },
  { label: $i18n.t('compensationManagement.falseDelivery'), value: 8 },
  { label: $i18n.t('compensationManagement.otherType'), value: 9 }
];

// 进线原因列表（用于高级搜索多选下拉，value 为数字代码 1~17）
export const contactReasonList = [
  { label: $i18n.t('compensationManagement.contactReason_1'), value: 1 },
  { label: $i18n.t('compensationManagement.contactReason_2'), value: 2 },
  { label: $i18n.t('compensationManagement.contactReason_3'), value: 3 },
  { label: $i18n.t('compensationManagement.contactReason_4'), value: 4 },
  { label: $i18n.t('compensationManagement.contactReason_5'), value: 5 },
  { label: $i18n.t('compensationManagement.contactReason_6'), value: 6 },
  { label: $i18n.t('compensationManagement.contactReason_7'), value: 7 },
  { label: $i18n.t('compensationManagement.contactReason_8'), value: 8 },
  { label: $i18n.t('compensationManagement.contactReason_9'), value: 9 },
  { label: $i18n.t('compensationManagement.contactReason_10'), value: 10 },
  { label: $i18n.t('compensationManagement.contactReason_11'), value: 11 },
  { label: $i18n.t('compensationManagement.contactReason_12'), value: 12 },
  { label: $i18n.t('compensationManagement.contactReason_13'), value: 13 },
  { label: $i18n.t('compensationManagement.contactReason_14'), value: 14 },
  { label: $i18n.t('compensationManagement.contactReason_15'), value: 15 },
  { label: $i18n.t('compensationManagement.contactReason_16'), value: 16 },
  { label: $i18n.t('compensationManagement.contactReason_17'), value: 17 }
];

// 函数可根据当前语言环境按需返回本地化的进线原因列表
export const getContactReasonList = () => [
  { label: $i18n.t('compensationManagement.contactReason_1'), value: 1 },
  { label: $i18n.t('compensationManagement.contactReason_2'), value: 2 },
  { label: $i18n.t('compensationManagement.contactReason_3'), value: 3 },
  { label: $i18n.t('compensationManagement.contactReason_4'), value: 4 },
  { label: $i18n.t('compensationManagement.contactReason_5'), value: 5 },
  { label: $i18n.t('compensationManagement.contactReason_6'), value: 6 },
  { label: $i18n.t('compensationManagement.contactReason_7'), value: 7 },
  { label: $i18n.t('compensationManagement.contactReason_8'), value: 8 },
  { label: $i18n.t('compensationManagement.contactReason_9'), value: 9 },
  { label: $i18n.t('compensationManagement.contactReason_10'), value: 10 },
  { label: $i18n.t('compensationManagement.contactReason_11'), value: 11 },
  { label: $i18n.t('compensationManagement.contactReason_12'), value: 12 },
  { label: $i18n.t('compensationManagement.contactReason_13'), value: 13 },
  { label: $i18n.t('compensationManagement.contactReason_14'), value: 14 },
  { label: $i18n.t('compensationManagement.contactReason_15'), value: 15 },
  { label: $i18n.t('compensationManagement.contactReason_16'), value: 16 },
  { label: $i18n.t('compensationManagement.contactReason_17'), value: 17 }
];

// 进线原因代码与多语言名称对照表
export const contactReasonObj = {
  1: $i18n.t('compensationManagement.contactReason_1'),
  2: $i18n.t('compensationManagement.contactReason_2'),
  3: $i18n.t('compensationManagement.contactReason_3'),
  4: $i18n.t('compensationManagement.contactReason_4'),
  5: $i18n.t('compensationManagement.contactReason_5'),
  6: $i18n.t('compensationManagement.contactReason_6'),
  7: $i18n.t('compensationManagement.contactReason_7'),
  8: $i18n.t('compensationManagement.contactReason_8'),
  9: $i18n.t('compensationManagement.contactReason_9'),
  10: $i18n.t('compensationManagement.contactReason_10'),
  11: $i18n.t('compensationManagement.contactReason_11'),
  12: $i18n.t('compensationManagement.contactReason_12'),
  13: $i18n.t('compensationManagement.contactReason_13'),
  14: $i18n.t('compensationManagement.contactReason_14'),
  15: $i18n.t('compensationManagement.contactReason_15'),
  16: $i18n.t('compensationManagement.contactReason_16'),
  17: $i18n.t('compensationManagement.contactReason_17')
};

// 函数可根据当前语言环境按需返回本地化的进线原因对照表
export const getContactReasonObj = () => ({
  1: $i18n.t('compensationManagement.contactReason_1'),
  2: $i18n.t('compensationManagement.contactReason_2'),
  3: $i18n.t('compensationManagement.contactReason_3'),
  4: $i18n.t('compensationManagement.contactReason_4'),
  5: $i18n.t('compensationManagement.contactReason_5'),
  6: $i18n.t('compensationManagement.contactReason_6'),
  7: $i18n.t('compensationManagement.contactReason_7'),
  8: $i18n.t('compensationManagement.contactReason_8'),
  9: $i18n.t('compensationManagement.contactReason_9'),
  10: $i18n.t('compensationManagement.contactReason_10'),
  11: $i18n.t('compensationManagement.contactReason_11'),
  12: $i18n.t('compensationManagement.contactReason_12'),
  13: $i18n.t('compensationManagement.contactReason_13'),
  14: $i18n.t('compensationManagement.contactReason_14'),
  15: $i18n.t('compensationManagement.contactReason_15'),
  16: $i18n.t('compensationManagement.contactReason_16'),
  17: $i18n.t('compensationManagement.contactReason_17')
});
// 投诉工单  ===>  状态
export const complaintStatusObj = {
  0: $i18n.t('GlobalSetObj.Pending'), // 待处理
  1: $i18n.t('newOrder.processing'), // 处理中
  2: $i18n.t('collectionCenter.closedLoop'), // 已闭环
  3: $i18n.t('collectionCenter.cancelled') // 已取消
};
// 岗位
export const positionListObj = {
  1: $i18n.t('home.collection'), // 揽收
  2: $i18n.t('home.sorting'), // 分拣
  3: $i18n.t('home.transportation') // 运输
};
// 岗位列表
export const positionList = [
  { label: $i18n.t('home.collection'), value: 1 }, // 揽收
  { label: $i18n.t('home.sorting'), value: 2 }, // 分拣
  { label: $i18n.t('home.transportation'), value: 3 } // 分拣
];
export const progressListObj = {
  1: $i18n.t('ClaimsManagement.ToBeSubmitted'), // 待提交
  2: $i18n.t('Resource.underReview'), // 审核中
  3: $i18n.t('customerManagements.approved'), // 审核通过
  4: $i18n.t('home.unapplivefail'), // 审核未通过
  5: $i18n.t('GlobalSetObj.Rejected'), // 已拒绝
  6: $i18n.t('seller.expired') // 已失效
};
// 处理结果
export const resultObj = {
  1: $i18n.t('seller.resubmit'), // 重新提交
  2: $i18n.t('seller.rejectRegistration') // 拒绝注册
};
// 投诉来源
export const complaintSource = [
  { label: $i18n.t('tablePrice.consumerComplaint'), value: 0 },
  { label: $i18n.t('tablePrice.platformComplaint'), value: 1 }
];
// 处理结果
export const complaintType3 = [
  { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 0 },
  { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
  { label: $i18n.t('tablePrice.invalidResponse'), value: 8 }
];
// 分拣条件
export const conditionTypes = [
  {
    value: 'MDFE',
    label: $i18n.t('CenterForSorting.MDFE')
  },
  {
    value: 'PROBLEM_PIECE',
    label: $i18n.t('CenterForSorting.PROBLEM_PIECE')
  },
  {
    value: 'CARRIER',
    label: $i18n.t('CenterForSorting.CARRIER')
  },
  {
    value: 'CUSTOMER',
    label: $i18n.t('CenterForSorting.CUSTOMER')
  },
  {
    value: 'NETWORK_POINT',
    label: $i18n.t('CenterForSorting.NETWORK_POINT')
  },
  {
    value: 'SORT_FAIL',
    label: $i18n.t('CenterForSorting.SORT_FAIL')
  },
  {
    value: 'TRANSFER_CENTER',
    label: $i18n.t('CenterForSorting.TRANSFER_CENTER')
  },
  {
    value: 'WAYBILL_STATUS',
    label: $i18n.t('CenterForSorting.WAYBILL_STATUS')
  },
  {
    value: 'ZIP_CODE',
    label: $i18n.t('CenterForSorting.ZIP_CODE')
  },
  {
    value: 'PROBLEM_PIECE_STATUS',
    label: $i18n.t('CenterForSorting.PROBLEM_PIECE_STATUS')
  },
  {
    value: 'PACKAGE_WEIGHT',
    label: $i18n.t('CenterForSorting.PACKAGE_WEIGHT')
  },
  {
    value: 'DEFAULT',
    label: $i18n.t('CenterForSorting.DEFAULT')
  },
  {
    value: 'MACHINE_FALLBACK',
    label: $i18n.t('CenterForSorting.MACHINE_FALLBACK')
  }
];
export const waybillStatusListRule = [
  { label: $i18n.t('collectionCenter.orderPlaced'), code: 30 }, // 已下单
  { label: $i18n.t('newOrder.ToBeCollected'), code: 2 }, // 待揽收
  { label: $i18n.t('newOrder.Collected'), code: 3 }, // 已揽收
  { label: $i18n.t('newOrder.TransshipmentIntoStorage'), code: 6 }, // 转运入库
  { label: $i18n.t('newOrder.TransferOutWarehouse'), code: 7 }, // 转运出库
  { label: $i18n.t('newOrder.DeliveryOutletsIntoStorage'), code: 8 }, // 派送网点入库
  { label: $i18n.t('newOrder.Delivering'), code: 9 }, // 派送中
  { label: $i18n.t('newOrder.Signed'), code: 10 }, // 已签收
  { label: $i18n.t('newOrder.ProblemPiece'), code: 11 }, // 问题件
  { label: $i18n.t('GlobalSetObj.warehouseRetentionItem'), code: 29 }, // 留仓件
  { label: $i18n.t('GlobalSetObj.Canceled'), code: 13 }, // 已取消
  { label: $i18n.t('GlobalSetObj.DotBack'), code: 17 }, // 网点退回
  { label: $i18n.t('GlobalSetObj.ReturnToStorage'), code: 18 }, // 退仓入库
  { label: $i18n.t('scripting.inReturnNotIncludingOriginalD2D'), code: 15 }, // 退件中(不包含原单退件D2D)
  { label: $i18n.t('GlobalSetObj.TheReturnComplete'), code: 16 }, // 退件完成
  { label: $i18n.t('GlobalSetObj.mutilSign'), code: 20 }, // 多次签收
  { label: $i18n.t('GlobalSetObj.acceptCarriageSwitch'), code: 27 } // 承运更换
];
